import { useEffect, useState } from "react";
import AudioDevice from "../../services/recorder/AudioDevice";
import RecorderService from "../../services/recorder/RecorderService";
import { MenuItem, Select } from "@material-ui/core";
import FirebaseService from "../../services/firebase/FirebaseService";
import LogService from "../../services/LogService";
import { useSelector } from "react-redux";
import { RootState } from "../../state/configureStore";

const AudioDeviceSelector = () => {
  const [audioDevices, setAudioDevices] = useState<AudioDevice[]>([]);
  const userId = useSelector((state: RootState) => state.currentUserState.currentUser?.uid) || "";
  const selectedAudioDevice =
    useSelector((state: RootState) => state.currentUserState.currentUserSettings?.audioDevice) || "";

  useEffect(() => {
    RecorderService.listAudioDevices().then(devices => {
      setAudioDevices(devices);
      // Figure out what audio device should be selected.
      // This needs to check the user's selected device.
      // If there isn't one, try the default.  Otherwise
      // just the first one.
      if (devices.length > 0) {
        const defaultDevices = devices.filter(obj => obj.isSystemDefault);
        if (selectedAudioDevice === "") {
          const deviceId = defaultDevices[0] ? defaultDevices[0].deviceId : devices[0]?.deviceId;
          FirebaseService.updateUserSettings(userId, "audioDevice", deviceId).catch(err => {
            LogService.exception(
              err,
              `AudioDeviceSelector.updateSelectedAudioDevice`,
              "Failed to update audio device.",
            );
          });
        }
      }
    });
  }, [selectedAudioDevice, userId]);

  const updateSelectedAudioDevice = (deviceId: string) => {
    FirebaseService.updateUserSettings(userId, "audioDevice", deviceId).catch(err => {
      LogService.exception(err, `AudioDeviceSelector.updateSelectedAudioDevice`, "Failed to update audio device.");
    });
  };

  return (
    <Select
      value={selectedAudioDevice}
      className="microphone-select"
      onChange={event => updateSelectedAudioDevice(event.target.value as string)}
    >
      {audioDevices.length > 0 &&
        audioDevices.map(device => (
          <MenuItem key={device.deviceId} value={device.deviceId}>
            {device.label}
          </MenuItem>
        ))}
      {
        // If there are no audio devices found, put in a default item.
        audioDevices.length === 0 && <MenuItem value="none">No Audio Devices Found</MenuItem>
      }
    </Select>
  );
};

export default AudioDeviceSelector;
